import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { FormField, DFormControl } from "app/shared/modules/ngx-dynamic-forms/entities";

export interface DImgSelectFormControl extends DFormControl {
	type: "select";
	value: string[] | number[];
	options: [
		{
			value: string | number;
			label?:
				| string
				| {
						[language: string]: string;
				  };
			image?: string;
		},
	];
}

@Component({
	selector: "form-select",
	template: `
		<div class="dynamic-field form-select" [formGroup]="group">
			<label>
				<ng-content select="h3" />
				<pv-select
					[attr.data-test]="config.name + '-select'"
					[formControlName]="config.name"
					[placeholder]="(config.placeholder | language) || ''"
				>
					@for (option of config.options; track option) {
						<pv-option [attr.data-test]="'option-' + option.value" [value]="option.value">
							<p class="option">
								@if (option.label) {
									<span>
										{{ option.label | language }}
									</span>
								}
								@if (option.image) {
									<img [alt]="option.label | language" [src]="'./assets/images/' + option.image" />
								}
							</p>
						</pv-option>
					}
				</pv-select>
			</label>

			@if (hasError("required")) {
				<div class="error">
					{{ "general.errors.required_field" | translate }}
				</div>
			}
		</div>
	`,
	styleUrls: ["select.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FormSelectComponent implements FormField {
	// @ts-expect-error TS2564
	@Input() config: DImgSelectFormControl;
	// @ts-expect-error TS2564
	@Input() group: UntypedFormGroup;

	hasError(error: string): boolean {
		const control = this.group.get(this.config.name);
		// @ts-expect-error TS18047
		return control.touched && !!control.errors?.[error];
	}
}
